import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
// import DeleteProductModal from "../DeleteProductModal/DeleteProductModal";
// import DeleteProductModal from "../DeleteProductModal/DeleteProductModal";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import MarketPlaceNav from "../../Marketplace/MarketPlaceNav/MarketPlaceNav";
import "./ProductList.css";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";
import Nodata from "../../../../../../../assets/Icon/Nodata.png";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";
const ProductList = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [buffer, setBuffer] = useState(true);
  const [product, setProduct] = useState([]);
  const [allstatus, setStatus] = useState("");

  const location = useLocation();

  // function handleClick() {
  //   history.push("/superstar-admin/edit-marketplace");
  // }

  useEffect(() => {
    if (location.pathname === "/superstar-admin/product-list/approved") {
      axios.get(`/api/admin/marketplace/product-list/approved`).then((res) => {
        setBuffer(false);
        if (res.data.status === 200) {
          setProduct(res.data.approved);
          setStatus("approved");
        }
      });
    }
    if (location.pathname === "/superstar-admin/product-list/pending") {
      axios.get(`/api/admin/marketplace/product-list/pending`).then((res) => {
        setBuffer(false);
        if (res.data.status === 200) {
          setProduct(res.data.pending);
          setStatus("pending");
        }
      });
    }
  }, [location]);

  return (
    <div className="container-fluid">
      <>
        <div className="row">
          <MarketPlaceNav />

          <h3 className="text-light p-3 head-line">
            {allstatus === "approved" ? "Approved" : "Pending"} Product List
          </h3>
          {buffer ? (
            <LoaderPost />
          ) : (
            <>
              {product !== 0 ? (
                <div className="row">
                  {product.map((product, index) => (
                    <div className="col-md-12 col-lg-6  my-4">
                      <div className="border-warning product-card">
                        <div className="">
                          <div className="row">
                            <div className="col-md-6 d-flex justify-content-center text-center">
                              <div className="div-img d-flex justify-content-center align-items-center">
                                <img
                                  src={imageCdnUrl + product.image}
                                  className="img-fluid img-style-sold"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="p-4">
                                <h3 className="text-warning fw-bolder title-limit">
                                  <i>{product.title}</i>
                                </h3>
                                <small className="text-muted">
                                  Released on{" "}
                                  {moment(product.created_at).format("LL")} -{" "}
                                  {moment(product.created_at).format("LT")}
                                </small>

                                <p className="text-white title-limit">
                                  <Markup
                                    content={product.description.substring(
                                      0,
                                      200
                                    )}
                                  />
                                </p>
                                <div className="row eleven-one-parents">
                                  <div className="col-md-9 ms-3">
                                    <div className="row text-sold-font">
                                      <div className="row bg-gray">
                                        <div className="col-4">
                                          <small className="text-light">
                                            Units
                                          </small>
                                        </div>
                                        <div className="col-8 d-flex justify-content-end">
                                          <small className="text-light mx-4">
                                            {product.total_items}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="row  bg-gray mt-3">
                                        <div className="col-4">
                                          <small className="text-light">
                                            Price
                                          </small>
                                        </div>
                                        <div className="col-8 d-flex justify-content-end">
                                          <small className="text-light mx-4">
                                            <span>$ </span>
                                            {product.unit_price.toFixed(2)}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="row  bg-gray mt-3">
                                        <div className="col-4">
                                          <small className="text-light">
                                            Sold
                                          </small>
                                        </div>
                                        <div className="col-8 d-flex justify-content-end">
                                          <small className="text-light mx-4">
                                            {product.total_selling}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="row  bg-gray mt-3">
                                        <div className="col-4">
                                          <small className="text-light">
                                            Left
                                          </small>
                                        </div>
                                        <div className="col-8 d-flex justify-content-end">
                                          <small className="text-light mx-4">
                                            {product.total_items -
                                              product.total_selling}
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-2 d-flex justify-content-center">
                                    {/* <div className="d-flex justify-content-center align-items-center"> */}
                                    <div className="div-img d-flex justify-content-center align-items-center ">
                                      <div className="pt-3">
                                        {/* <div className="my-3">
                                <button type="button" onClick={handleClick} className="btn btn-warning"><i className="fa-solid fa-pencil icon-soldProduct"></i></button>

                              </div> */}

                                        {location.pathname ===
                                        "/superstar-admin/product-list/pending" ? (
                                          <>
                                            {Number(product.post_status) ===
                                            0 ? (
                                              <div className="my-3">
                                                <Link
                                                  to={`/superstar-admin/edit-marketplace/${product.id}`}
                                                  className="btn btn-success me-2"
                                                >
                                                  <i className="fa-solid fa-pencil icon-soldProduct"></i>
                                                </Link>
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            <div className="">
                                              <Link
                                                to={`/superstar-admin/confirm-or-edit-marketplace/${product.id}`}
                                                className="btn btn-danger"
                                              >
                                                <i className="fa-solid fa-eye icon-soldProduct"></i>
                                              </Link>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="">
                                            <Link
                                              to={`/superstar-admin/confirm-or-edit-marketplace/${product.id}`}
                                              className="btn btn-danger"
                                            >
                                              <i className="fa-solid fa-eye icon-soldProduct"></i>
                                            </Link>
                                          </div>
                                        )}

                                        {/* <div className="">
                                <button onClick={() => setModalShow(true)} className="btn btn-light"> <i className="fa-solid fa-eye icon-deleteProduct"></i></button>

                              </div> */}
                                      </div>

                                      {/* <DeleteProductModal
                              show={modalShow}
                              onHide={() => setModalShow(false)}
                            /> */}
                                    </div>

                                    {/* </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  {" "}
                  <div className="row justify-content-center align-items-center">
                    <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                      <img src={Nodata} alt="" className=" Nodata" />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </>
    </div>
  );
};

export default ProductList;
